import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { Building2, MapPin, Landmark, Star } from "lucide-react";

const KomikPoznan = () => (
  <SeoPageLayout title="Komik i stand-up" titleAccent="Poznań">
    <SeoSection title="Występy komediowe w Poznaniu">
      <p>Poznań to jedno z najważniejszych miast biznesowych w Polsce, znane z Międzynarodowych Targów Poznańskich i dynamicznie rozwijającego się sektora korporacyjnego. Oferujemy profesjonalne występy komediowe na terenie Poznania i Wielkopolski - od kameralnych imprez firmowych po duże konferencje branżowe i gale.</p>
    </SeoSection>

    <SeoSection title="Eventy firmowe w Poznaniu">
      <p>Poznański rynek eventowy jest jednym z najbardziej rozwiniętych w Polsce. Firmy z branży spożywczej, logistycznej, IT i przemysłowej regularnie organizują spotkania integracyjne, konferencje i bankiety. Nasi komicy doskonale znają poznańską specyfikę i potrafią nawiązać do lokalnej kultury, humoru i tradycji wielkopolskiej.</p>
    </SeoSection>

    <SeoSection title="Popularne lokalizacje eventowe w Poznaniu">
      <SeoFeatureGrid features={[
        { icon: Landmark, title: "Targi Poznańskie (MTP)", description: "Międzynarodowe Targi Poznańskie i Centrum Kongresowe ILF" },
        { icon: Building2, title: "Hotele premium", description: "Sheraton, IBB Andersia, DoubleTree by Hilton" },
        { icon: Star, title: "Stary Browar", description: "Przestrzenie eventowe i konferencyjne w kultowym kompleksie" },
        { icon: MapPin, title: "Stary Rynek", description: "Restauracje i sale bankietowe w sercu Poznania" },
      ]} />
    </SeoSection>

    <SeoSection title="Zamów komika w Poznaniu">
      <p>Organizujesz event firmowy w Poznaniu? Skontaktuj się z nami i opisz swoje potrzeby. Zaproponujemy idealny format występu komediowego - od klasycznego stand-upu, przez roast, po interaktywne show z udziałem publiczności. Działamy na terenie całej Wielkopolski.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikPoznan;
